import { BreadcrumbIconLoaderType } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbIconLoaders/BreadcrumbIconLoaderType";
import { HomeBreadcrumbIconLoader } from "./HomeBreadcrumbIconLoader";

export const BreadcrumbIconLoaderTypes: BreadcrumbIconLoaderType[] = [
  HomeBreadcrumbIconLoader,
];
